module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("73mNu"))).then(() => parcelRequire('1iHdE'));